import { Text } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.semiBold,
      textAlign: 'center',
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      backgroundColor: 'transparent',
      color: theme.colorTextNeutralDefault,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      orientation: {
        vertical: {
          paddingTop: theme.spacingStackTwopulse,
          paddingLeft: theme.paddingInsetNone,
          paddingRight: theme.paddingInsetNone,
        },
        horizontal: {
          paddingLeft: theme.spacingStackTwopulse,
        },
      },
    },
  }
})
